import {
  PREPARING_DOWNLOAD_ALL_ATTACHMENTS_LOADING,
  PREPARING_DOWNLOAD_ALL_ATTACHMENTS_SUCCESS,
  PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const downloadFromLocal = (url) => (dispatch) => {
  dispatch({
    type: PREPARING_DOWNLOAD_ALL_ATTACHMENTS_SUCCESS,
  });
  window.location = url;
};

export const downloadFromWarehouse = (url) => (dispatch) => {
  fetch({
    url,
    method: `HEAD`,
    cors: true,
    detailed: true,
  })
    .then((response) => {
      if (response.status === 202) {
        setTimeout(() => {
          dispatch(downloadFromWarehouse(url));
        }, 2000);
      } else {
        dispatch({
          type: PREPARING_DOWNLOAD_ALL_ATTACHMENTS_SUCCESS,
        });
        window.location = url;
      }
    })
    .catch((error) => {
      dispatch({
        type: PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR,
        error,
      });
    });
};

export const downloadArchive = (url) => (dispatch) => {
  if (Angie.functions.get_domain(url) === Angie.functions.get_domain(Angie.root_url)) {
    dispatch(downloadFromLocal(url));
  } else {
    dispatch(downloadFromWarehouse(url));
  }
};

export const startPreparingDownload =
  (url, download_token = "") =>
  (dispatch) => {
    dispatch({
      type: PREPARING_DOWNLOAD_ALL_ATTACHMENTS_LOADING,
    });

    fetch({
      url,
      method: `post`,
    }).then(
      (response) => {
        if (response && response.download_url) {
          let download_url = response.download_url.replace("--DOWNLOAD-TOKEN--", download_token);
          dispatch(downloadArchive(download_url));
        } else {
          dispatch({
            type: PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR,
            error: new Error(`Could not prepare archive for download`),
          });
        }
      },
      (error) => {
        dispatch({
          type: PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR,
          error,
        });
      }
    );
  };
